import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'Wager Wars';

  constructor(
    private router: Router,
  ) { }

  ngOnInit(): void {
    var isLoggedIn = localStorage.getItem("isLoggedIn");
    if (location.pathname.startsWith('/reset')) {
      //Ignore
    }
    else if (isLoggedIn === undefined || isLoggedIn === null || isLoggedIn !== "true") {
      this.router.navigate(['/auth/login']);
    }
  }


}
